import React from 'react';

import Chip from '@mui/material/Chip';

import ICONS from '../common/Icons';

const {
  Wifi,
  Wired,
  Android,
  Chrome,
  Firefox,
  Safari,
  Laptop,
  Windows,
  Apple,
  UbuntuLinux,
  Linux,
  CentOSLinux,
  FedoraLinux,
  Ios,
  Unknown,
  RJ45,
} = ICONS;

export const osToIcon = (os = '') => {
  let title = 'Unknown';
  let icon = <Unknown />;
  if (!os) {
    return icon;
  }
  const oslc = os.toLowerCase();
  switch (true) {
    case oslc.indexOf('win') > -1:
      icon = <Windows titleAccess="Windows" />;
      break;
    case oslc.indexOf('android') > -1:
      icon = (
        <Android
          viewBox="0 0 36 36"
          width="36"
          height="36"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.25"
          titleAccess="Android"
        />
      );
      title = 'Android';
      break;
    case oslc.indexOf('apple os') > -1:
      icon = <Apple titleAccess="Apple" />;
      title = 'Mac';
      break;
    case oslc.indexOf('centos') > -1:
      icon = (
        <CentOSLinux
          viewBox="0 0 36 36"
          width="36"
          height="36"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.25"
          titleAccess="Centos"
        />
      );
      title = 'Centos';
      break;
    case oslc.indexOf('fedora') > -1:
      icon = (
        <FedoraLinux
          viewBox="0 0 36 36"
          width="36"
          height="36"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.25"
          titleAccess="Fedora"
        />
      );
      title = 'Fedora';
      break;
    case oslc.indexOf('linux') > -1:
      icon = (
        <Linux
          viewBox="0 0 36 36"
          width="36"
          height="36"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.25"
          titleAccess="Linux"
        />
      );
      title = 'Linux';
      break;
    case oslc.indexOf('ubuntu') > -1:
      icon = (
        <UbuntuLinux
          viewBox="0 0 36 36"
          width="36"
          height="36"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.25"
          titleAccess="Ubuntu"
        />
      );
      title = 'Ubuntu';
      break;
    case oslc.indexOf('ios') > -1:
      icon = (
        <Ios
          viewBox="0 0 36 36"
          width="36"
          height="36"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.25"
          titleAccess="iOS"
        />
      );
      title = 'iOS';
      break;
    case oslc.indexOf('chrome') > -1:
      icon = (
        <Chrome
          viewBox="0 0 36 36"
          width="36"
          height="36"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.25"
          titleAccess="iOS"
        />
      );
      title = 'iOS';
      break;

    case oslc.indexOf('unknown') > -1:
      icon = <Unknown titleAccess="Unknown" />;
      break;
    default:
      icon = <Chip variant="outlined" label={os} size="small" />;
      title = os || '-';
      break;
  }

  return icon;
};
